import { createContext, useContext } from 'react'
import { type SendFromStore } from '../store/SendFromStore'

export const SendFromContext = createContext<SendFromStore | null>(null)

export const useSendFromContext = () => {
  const context = useContext(SendFromContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SendFromContext')

  return context
}
